// @flow

import React from 'react';
import { useDispatch } from 'react-redux';

import { AudioSettingsButton, VideoSettingsButton } from '../../../../toolbox/components/web';
import { Avatar } from '../../../avatar';
import { devicePermissionsChanged } from '../../../devices';
import MeetHourJS, { MHMediaDevicesEvents } from '../../../lib-meet-hour';
import { Video } from '../../../media';
import { connect } from '../../../redux';
import { getLocalVideoTrack } from '../../../tracks';

export type Props = {

    /**
     * Flag signaling the visibility of camera preview.
     */
    videoMuted: boolean,


    /**
     * ShowAvatar.
     */
    showAvatar: boolean,

    /**
     * Name of the user.
     */
     name: String,

    /**
     * The MHLocalTrack to display.
     */
    videoTrack: ?Object,

    /**
     * HasPermissions.
     */
     hasPermissions: ?Object
};

/**
 * A listener for device permissions changed reported from lib-meet-hour.
 */
let permissionsListener;

const styleHeight = {
    minHeight: '100%'
};

const styledAudio = {
    display: 'inline-block'
};

const styleDivVideo = {
    background: '0 0',
    ...styledAudio,
    maxHeight: '344px'
};

/**
 * Component showing the video preview and device status.
 *
 * @param {Props} props - The props of the component.
 * @returns {ReactElement}
 */
function Preview(props: Props) {
    const { videoMuted, videoTrack, showAvatar, name, hasPermissions } = props;
    const dispatch = useDispatch();

    const onUserAudioclick = () => {

        const _permissionsListener = permissions => {
            dispatch(devicePermissionsChanged(permissions));
        };

        navigator.permissions.query([
            'audio'
        ]).then();
        const { mediaDevices } = MeetHourJS;

        permissionsListener = _permissionsListener;
        mediaDevices.addEventListener(MHMediaDevicesEvents.PERMISSIONS_CHANGED, permissionsListener);
        Promise.all([
            mediaDevices.isDevicePermissionGranted('audio')
        ])
        .then(results => {
            _permissionsListener({
                audio: results[0]
            });
        })
        .catch(() => {
            // Ignore errors.
        });
    };

    const onUserVideoclick = () => {
        const _permissionsListener = permissions => {
            dispatch(devicePermissionsChanged(permissions));
        };
        const { mediaDevices } = MeetHourJS;

        permissionsListener = _permissionsListener;
        mediaDevices.addEventListener(MHMediaDevicesEvents.PERMISSIONS_CHANGED, permissionsListener);
        Promise.all([
            mediaDevices.isDevicePermissionGranted('video')
        ])
        .then(results => {
            _permissionsListener({
                video: results[0]
            });
        })
        .catch(() => {
            // Ignore errors.
        });
    };


    return (
        <div id = 'preview'>
            <div
                className = 'user-preview'>
                {(videoMuted || videoTrack === undefined) && showAvatar && (
                    <div style = {{ ...styleHeight }}>
                        <Avatar
                            className = 'premeeting-screen-avatar'
                            displayName = { name }
                            dynamicColor = { false }
                            participantId = 'local'
                            size = { 80 } />
                    </div>
                )}
                {
                    !videoMuted && videoTrack && (
                        <Video
                            videoTrack = {{ mhTrack: videoTrack }} />
                    )
                }
                <div className = 'toolbox-content-items1'>
                    <div
                        onClick = { hasPermissions.audio ? undefined : onUserAudioclick }
                        style = { styledAudio }>
                        <AudioSettingsButton visible = { true } />
                    </div>
                    <div
                        onClick = { hasPermissions.video ? undefined : onUserVideoclick }
                        style = { styleDivVideo }>
                        <VideoSettingsButton visible = { true } />
                    </div>
                </div>
            </div>
        </div>
    );


}

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @param {Props} ownProps - The own props of the component.
 * @returns {Props}
 */
function _mapStateToProps(state, ownProps) {
    const { permissions = {} } = state['features/base/devices'];

    return {
        hasPermissions: permissions,
        videoMuted: ownProps.videoTrack ? ownProps.videoMuted : state['features/base/media'].video.muted === 0,
        videoTrack: ownProps.videoTrack || (getLocalVideoTrack(state['features/base/tracks']) || {}).mhTrack
    };
}

export default connect(_mapStateToProps)(Preview);
